import { Model as t } from "../../../model.js";
class o extends t {
  constructor(e) {
    super(), this.id = e.id, this.code = e.code, this.scope = e.scope, this.status = e.status, this.name = e.name, this.startDate = e.startDate, this.endDate = e.endDate, this.settings = e.settings, this.design = e.design;
  }
}
export {
  o as StampProgrammeModel
};
//# sourceMappingURL=stampProgramme.model.js.map
